import { Directive, ElementRef, HostListener, inject } from "@angular/core";

@Directive({
    selector: '[pwdChangeDirective]',
    standalone: true
})
export class PwdChangeDirective {

    regex = '^[a-zA-Z0-9!$%&/()=?@#.]*$';

    private el = inject(ElementRef);

    @HostListener('keypress', ['$event'])
    onKeyPress(event: KeyboardEvent) {
        return new RegExp(this.regex).test(event.key);
    }

    @HostListener('paste', ['$event'])
    blockPaste(event: ClipboardEvent) {
        this.validateFields(event);
    }

    private validateFields(event: ClipboardEvent) {
        event.preventDefault();
        const pasteData = event.clipboardData.getData('text/plain').replace(/[^a-zA-Z0-9!$%&/()=?@#.]/g, '');
        document.execCommand('insertHTML', false, pasteData);
    }
}